module.exports = __webpack_public_path__ + "static/img/image_recruit_02.eae2fa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/join/image_recruit_02.png
// module id = BXMi
// module chunks = 10